<template>
  <div>
    <v-dialog v-model="dialog.filter"
      @keydown.esc="dialog.filter = false"
      :fullscreen="dialog.fullscreen"
      width="600"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
        <v-card-title 
          class="d-flex align-center pa-4 text-right popup-header">
          <div
            class="title font-weight-bold">
            Filter Data
          </div>

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.filter = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider 
          class="mb-0"
          style="border-top: 2px dashed #e0e0e0;"/>

        <v-card-text 
          class="py-0 my-1">
          <div>
            <v-row>
              <v-col cols="12" class="pa-0">
                <!-- <v-list two-line class="py-0">
                  <v-list-item-group
                  v-model="selected"
                  active-class="color-filter"
                  > -->
                  <div v-for="(item, index) in filter_list" :key="index">
                    <v-list two-line class="py-0">
                      <v-list-item @click="selected = index; index !== 1 ? fetch() : ''">
                        <v-list-item-content>
                          <v-list-item-title>{{ item.name }}</v-list-item-title>

                          <v-list-item-subtitle
                            v-if="item.date.start !== '' && item.date.end !== ''"
                          >
                          <span v-if="item.date.start === item.date.end">{{ item.date.start | date_full }}</span>
                          <span v-else>{{ item.date.start | date_full }} - {{ item.date.end | date_full }}</span>
                          </v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action>
                          <v-icon
                            v-if="selected !== index"
                            color="grey lighten-1"
                          >
                            mdi-radiobox-blank
                          </v-icon>

                          <v-icon
                            v-if="selected === index"
                            :color="set_color"
                          >
                            mdi-radiobox-marked
                          </v-icon>
                        </v-list-item-action>
                      </v-list-item>
                      <div v-if="selected === 1 && index === 1" class="px-3">
                        <v-row align="end">
                          <v-col cols="12" md="5">
                            <div class="fs-12 mb-1">
                              Tanggal Awal
                            </div>
                            <v-text-field
                              v-model="filter_list[1].date.start"
                              clearable
                              :color="set_color"
                              placeholder="Tanggal Awal"
                              hide-details
                              type="date"
                              filled
                              rounded
                              dense
                              class="fs-12 little-placeholder"
                              style="border-radius: 6px;"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="5">
                            <div class="fs-12 mb-1">
                              Tanggal Akhir
                            </div>

                            <v-text-field
                              v-model="filter_list[1].date.end"
                              clearable
                              :color="set_color"
                              placeholder="Tanggal Akhir"
                              hide-details
                              type="date"
                              filled
                              :min="filter_list[1].date.start"
                              rounded
                              dense
                              class="fs-12 little-placeholder"
                              style="border-radius: 6px;"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="2">
                            <v-btn
                              elevation="0"
                              width="100%"
                              :disabled="filter_list[1].date.start === '' || filter_list[1].date.end === '' || filter_list[1].date.start > filter_list[1].date.end || filter_list[1].date.end === null || filter_list[1].date.start === null"
                              small
                              min-height="30"
                              color="green"
                              class="text-capitalize px-0 white--text"
                              style="border-radius: 6px;"
                              @click="fetch()">
                              <!-- <v-icon size="18">mdi-filter</v-icon> -->
                               Filter
                            </v-btn>
                          </v-col>
                          <v-col cols="12" v-if="filter_list[1].date.end !== '' && filter_list[1].date.start > filter_list[1].date.end">
                            <v-alert
                              dense
                              type="error"
                            >
                              Tanggal akhir tidak boleh lebih kecil dari tanggal awal
                            </v-alert>
                          </v-col>
                        </v-row>
                      </div>
                      <v-divider
                        v-if="index < filter_list.length - 1"
                        :key="index"
                      ></v-divider>
                    </v-list>
                  </div>
                  <!-- </v-list-item-group>
                </v-list> -->

              </v-col>
            </v-row>
          </div>
        </v-card-text>
        
        <v-divider 
          class="mt-2"
          style="border-top: 2px dashed #e0e0e0;"/>

        <v-card-actions
          class="pa-4">
          <v-spacer/>

          <!-- <v-btn 
            @click="dialog.filter = false; toFilter();"
            width="120"
            elevation="0"
            color="green"
            rounded
            class="body-2 font-weight-bold text-capitalize white--text">
            Filter
          </v-btn> -->

          <v-btn 
            @click="dialog.filter = false"
            :disabled="process.form"
            width="120"
            outlined
            elevation="0"
            color="red"
            rounded
            class="body-2 font-weight-bold text-capitalize white--text">
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card flat>
      <v-card-text>
        <v-row>
          <v-col 
            cols="12">
            <v-card
              class="border-radius"
              color="#FFFFFF"
              style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
              <v-card-text
                class="d-flex align-center"
                style="flex-flow: wrap;">
                <v-avatar
                  tile
                  size="60">
                  <v-img 
                    alt="amanata" 
                    :src="require('@/assets/icon/statistik.png')"
                    class="ma-auto">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          indeterminate 
                          color="white">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-avatar>

                <div
                  class="ml-4 mb-1">
                  <div
                    class="title black--text"
                    style="font-weight: 600;">
                    Data Statistik
                  </div>

                  <div
                    class="body-2">
                    Periode 
                    <span>
                      {{ selected_date.name }} <span v-if="selected_date.name !== 'Semua Tanggal'">(
                        <span v-if="selected_date.start === selected_date.end">{{ selected_date.start | date_full }}</span>
                        <span v-else>{{ selected_date.start | date_full }} - {{ selected_date.end | date_full }}</span>
                        )</span>
                    </span>
                  </div>
                </div>

                <v-spacer />

                <div
                  class="d-flex align-center">
                  <div
                    class="body-2 black--text mr-2">
                    Periode :
                  </div>

                  <!-- <v-text-field
                    v-model="filter.start_date"
                    @input="fetch();"
                    clearable
                    @click:clear="fetch();"
                    :color="set_color"
                    placeholder="Pilihan tanggal"
                    hide-details
                    type="date"
                    filled
                    rounded
                    dense
                    class="fs-12 little-placeholder"
                    style="border-radius: 6px; max-width: 165px;"
                  ></v-text-field> -->
                  <v-btn
                    color="primary"
                    dark
                    elevation="0"
                    class="text-capitalize"
                    @click="dialog.filter = true"
                  >
                    <div>
                      {{ selected_date.name }} <span v-if="selected_date.name !== 'Semua Tanggal'">(
                        <span v-if="selected_date.start === selected_date.end">{{ selected_date.start | date_full }}</span>
                        <span v-else>{{ selected_date.start | date_full }} - {{ selected_date.end | date_full }}</span>
                        )</span>
                    </div>
                  </v-btn>

                  <!-- <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        
                        v-on="on"
                      >
                        Pilih Periode
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(item, index) in filter_list"
                        :key="index"
                      >
                        <v-list-item-title v-if="index !== 1" @click="filter.start_date = item.start; filter.end_date = item.end; fetch()">{{ item.name }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu> -->

                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="3">
            <v-card flat style="border-radius: 10px; height: 92px; background-color: #455A64;" v-if="process.load">
              <v-skeleton-loader
                
                type="image"
              ></v-skeleton-loader>
            </v-card>
            <v-card flat style="border-radius: 10px; background-color: #455A64;" v-if="!process.load">
              <v-card-text>
                <div class="d-flex white--text pb-0">
                  <div>
                    <div class="fs-16 font-weight-regular">
                      Jumlah Transaksi
                    </div>
                    <div class="mt-3 fs-22 font-weight-bold">
                      {{ detail.jumlah_transaksi }}
                    </div>
                  </div>
                  <div class="ml-auto">
                    <v-card flat class="pa-3" height="60px" width="60px" style="border-radius: 10px;">
                      <v-img :src="require('@/assets/icon/transaction-history.png')" width="55px"></v-img>
                    </v-card>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="3">
            <v-card flat style="border-radius: 10px; height: 92px; background-color: #EF6C00;" v-if="process.load">
              <v-skeleton-loader
                
                type="image"
              ></v-skeleton-loader>
            </v-card>
            <v-card bottom style="border-radius: 10px; background-color: #EF6C00;" v-if="!process.load">
              <v-tooltip bottom max-width="400">
                <template v-slot:activator="{ on, attrs }">
                  <v-card-text
                    v-bind="attrs"
                    v-on="on">
                    <div class="d-flex white--text pb-0">
                      <div>
                        <div class="fs-16 font-weight-regular">
                          Gross Sales
                        </div>
                        <div class="mt-3 fs-22 font-weight-bold">
                          {{ detail.gross_sales | price }}
                        </div>
                      </div>
                      <div class="ml-auto">
                        <v-card flat class="pa-3" height="60px" width="60px" style="border-radius: 10px;">
                          <v-img :src="require('@/assets/icon/sales-manager.png')" width="55px"></v-img>
                        </v-card>
                      </div>
                    </div>
                  </v-card-text>
                </template>
                <span>Gross sales atau pinjaman kotor adalah jumlah semua penjualan (grand total) atau jumlah yang diterima dari penjualan produk dengan status terbayar</span>
              </v-tooltip>

            </v-card>
          </v-col>
          <v-col cols="12" md="3">
            <v-card flat style="border-radius: 10px; height: 92px; background-color: #FF8F00;" v-if="process.load">
              <v-skeleton-loader
                
                type="image"
              ></v-skeleton-loader>
            </v-card>
            <v-card flat style="border-radius: 10px; background-color: #FF8F00;" v-if="!process.load">
              <v-tooltip bottom max-width="400">
                <template v-slot:activator="{ on, attrs }">
                  <v-card-text
                    v-bind="attrs"
                    v-on="on">
                    <div class="d-flex white--text pb-0">
                      <div>
                        <div class="fs-16 font-weight-regular">
                          Gross Profit
                        </div>
                        <div class="mt-3 fs-22 font-weight-bold">
                          {{ detail.gross_profit | price }}
                        </div>
                      </div>
                      <div class="ml-auto">
                        <v-card flat class="pa-3" height="60px" width="60px" style="border-radius: 10px;">
                          <v-img :src="require('@/assets/icon/profit-margin.png')" width="55px"></v-img>
                        </v-card>
                      </div>
                    </div>
                  </v-card-text>
                </template>
                <span>
                  <div>
                    Gross profit (Laba Kotor) = Pendapatan Penjualan Produk - Harga Pokok Penjualan
                  </div>
                  <div class="py-2">
                    <sup>**</sup>Pendapatan penjulan produk adalah jumlah uang yang diterima dari penjualan produk (grand total atau gross sales) dengan status terbayar
                  </div>
                  <div>
                    <sup>**</sup>Harga pokok penjulan (HPP) adalah harga beli produk.
                  </div>
                </span>
              </v-tooltip>
            </v-card>
          </v-col>
          <v-col cols="12" md="3">
            <v-card flat style="border-radius: 10px; height: 92px; background-color: #AD1457;" v-if="process.load">
              <v-skeleton-loader
                
                type="image"
              ></v-skeleton-loader>
            </v-card>
            <v-card flat style="border-radius: 10px; background-color: #AD1457;" v-if="!process.load">
              <v-tooltip bottom max-width="400">
                <template v-slot:activator="{ on, attrs }">
                  <v-card-text
                    v-bind="attrs"
                    v-on="on">
                    <div class="d-flex white--text pb-0">
                      <div>
                        <div class="fs-16 font-weight-regular">
                          Gross Profit Margin
                        </div>
                        <div class="mt-3 fs-22 font-weight-bold">
                          {{ (detail.gross_profit_margin).toFixed(2) }} %
                        </div>
                      </div>
                      <div class="ml-auto">
                        <v-card flat class="pa-3" height="60px" width="60px" style="border-radius: 10px;">
                          <v-img :src="require('@/assets/icon/margin.png')" width="55px"></v-img>
                        </v-card>
                      </div>
                    </div>
                  </v-card-text>
                </template>
                <span>
                  <div>
                    Gross Profit Margin adalah rasio persentase dari laba kotor (gross profit) dan penjualan kotor (gross sales)
                  </div>
                  <div class="py-2">
                    Gross Profit Margin = (Gross Profit / Pendapatan Penjualan Produk) x 100
                  </div>
                  <div>
                    <sup>**</sup>Pendaapatan penjualan produk adalah jumlah uang yang diterima dari penjualan produk (grand total atau gross sales) dengan status terbayar.
                  </div>
                </span>
              </v-tooltip>
            </v-card>
          </v-col>

          <v-col cols="12" md="3">
            <v-card flat style="border-radius: 10px; height: 92px; background-color: #757575;" v-if="process.load">
              <v-skeleton-loader
                
                type="image"
              ></v-skeleton-loader>
            </v-card>
            <v-card flat style="border-radius: 10px; background-color: #757575;" v-if="!process.load">
              <v-card-text>
                <div class="d-flex white--text pb-0">
                  <div>
                    <div class="fs-16 font-weight-regular">
                      Rata2 Penjualan / Transaksi
                    </div>
                    <div class="mt-3 fs-22 font-weight-bold">
                      Rp {{ formatPrice(detail.rata_rata_penjualan) }}
                    </div>
                  </div>
                  <div class="ml-auto">
                    <v-card flat class="pa-3" height="60px" width="60px" style="border-radius: 10px;">
                      <v-img :src="require('@/assets/icon/money-exchange.png')" width="55px"></v-img>
                    </v-card>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="3">
            <v-card flat style="border-radius: 10px; height: 92px; background-color: #039BE5;" v-if="process.load">
              <v-skeleton-loader
                
                type="image"
              ></v-skeleton-loader>
            </v-card>
            <v-card flat style="border-radius: 10px; background-color: #039BE5;" v-if="!process.load">
              <v-tooltip bottom max-width="400">
                <template v-slot:activator="{ on, attrs }">
                  <v-card-text
                    v-bind="attrs"
                    v-on="on">
                    <div class="d-flex white--text pb-0">
                      <div>
                        <div class="fs-16 font-weight-regular">
                          Net Sales
                        </div>
                        <div class="mt-3 fs-22 font-weight-bold">
                          {{ detail.net_sales | price }}
                        </div>
                      </div>
                      <div class="ml-auto">
                        <v-card flat class="pa-3" height="60px" width="60px" style="border-radius: 10px;">
                          <v-img :src="require('@/assets/icon/leader.png')" width="55px"></v-img>
                        </v-card>
                      </div>
                    </div>
                  </v-card-text>
                </template>
                <span>
                  Net sales atau penjualan bersih adalah jumlah semua penjualan (gross sales) dikurangi diskon atau potongan harga.
                </span>
              </v-tooltip>
            </v-card>
          </v-col>
          <v-col cols="12" md="3">
            <v-card flat style="border-radius: 10px; height: 92px; background-color: #00ACC1;" v-if="process.load">
              <v-skeleton-loader
                
                type="image"
              ></v-skeleton-loader>
            </v-card>
            <v-card flat style="border-radius: 10px; background-color: #00ACC1;" v-if="!process.load">
              <v-tooltip bottom max-width="400">
                <template v-slot:activator="{ on, attrs }">
                  <v-card-text
                    v-bind="attrs"
                    v-on="on">
                    <div class="d-flex white--text pb-0">
                      <div>
                        <div class="fs-16 font-weight-regular">
                          Net Profit
                        </div>
                        <div class="mt-3 fs-22 font-weight-bold">
                          {{ detail.net_profit | price }}
                        </div>
                      </div>
                      <div class="ml-auto">
                        <v-card flat class="pa-3" height="60px" width="60px" style="border-radius: 10px;">
                          <v-img :src="require('@/assets/icon/gross-margin.png')" width="55px"></v-img>
                        </v-card>
                      </div>
                    </div>
                  </v-card-text>
                </template>
                <span>
                  <div>
                    Net profit atau laba bersih adalah gross profit dikurang biaya.
                  </div>
                  <div class="pt-2">
                    <sup>**</sup>Biaya: layanan (servis), pajak (ppn), biaya lainnya dan pembulatan.
                  </div>
                </span>
              </v-tooltip>
              <!-- <v-card-text>
                <div class="d-flex white--text pb-0">
                  <div>
                    <div class="fs-16 font-weight-regular">
                      Net Profit
                    </div>
                    <div class="mt-3 fs-22 font-weight-bold">
                      {{ detail.net_profit | price }}
                    </div>
                  </div>
                  <div class="ml-auto">
                    <v-card flat class="pa-3" height="60px" width="60px" style="border-radius: 10px;">
                      <v-img :src="require('@/assets/icon/gross-margin.png')" width="55px"></v-img>
                    </v-card>
                  </div>
                </div>
              </v-card-text> -->
            </v-card>
          </v-col>
          <v-col cols="12" md="3">
            <v-card flat style="border-radius: 10px; height: 92px; background-color: #00897B;" v-if="process.load">
              <v-skeleton-loader
                
                type="image"
              ></v-skeleton-loader>
            </v-card>
            <v-card flat style="border-radius: 10px; background-color: #00897B;" v-if="!process.load">
              <v-tooltip bottom max-width="400">
                <template v-slot:activator="{ on, attrs }">
                  <v-card-text
                    v-bind="attrs"
                    v-on="on">
                    <div class="d-flex white--text pb-0">
                      <div>
                        <div class="fs-16 font-weight-regular">
                          Net Profit Margin
                        </div>
                        <div class="mt-3 fs-22 font-weight-bold">
                          {{ (detail.net_profit_margin).toFixed(2) }}%
                        </div>
                      </div>
                      <div class="ml-auto">
                        <v-card flat class="pa-3" height="60px" width="60px" style="border-radius: 10px;">
                          <v-img :src="require('@/assets/icon/profit.png')" width="55px"></v-img>
                        </v-card>
                      </div>
                    </div>
                  </v-card-text>
                </template>
                <span>
                  <div>
                    Net Profit Margin adalah rasio perbandingan laba bersih (net profit) dan penjualan bersih (net sales).
                  </div>
                  <div class="pt-2">
                    <sup>**</sup>Net Profit Margin = (Net Profit / Net Sales) x 100%.
                  </div>
                </span>
              </v-tooltip>
            </v-card>
          </v-col>
        </v-row>

        <v-card flat class="box-shadow">
          <v-card-text>
            <v-card flat style="border-radius: 10px; background-color: #1565C0;" v-if="process.load">
              <v-skeleton-loader
                
                type="image"
              ></v-skeleton-loader>
            </v-card>
            <div v-if="!process.load">
              <div id="chart">
                <apexchart type="bar" height="550" :options="chartOptions" :series="series"></apexchart>
              </div>
            </div>
          </v-card-text>
        </v-card>

        <v-row>
          <v-col cols="12" md="6">
            <v-card flat class="box-shadow">
              <v-card-text>
                <div class="d-flex pb-0">
                  <div>
                    <div class="fs-16 font-weight-medium">
                      Per Tipe Penjualan
                    </div>
                    <div class="mt-0 fs-14">
                      <div>
                        {{ selected_date.name }} <span v-if="selected_date.name !== 'Semua Tanggal'">(
                          <span v-if="selected_date.start === selected_date.end">{{ selected_date.start | date_full }}</span>
                          <span v-else>{{ selected_date.start | date_full }} - {{ selected_date.end | date_full }}</span>
                          )</span>
                      </div>
                    </div>
                  </div>
                  <div class="ml-auto">
                    <v-card flat class="pa-3" height="60px" width="60px" style="border-radius: 10px; background-color: #eee;">
                      <v-img :src="require('@/assets/icon/dana.png')" width="55px"></v-img>
                    </v-card>
                  </div>
                </div>
                <v-divider class="mt-2"></v-divider>
                <v-card flat style="border-radius: 10px; background-color: #2E7D32;" v-if="process.load">
                  <v-skeleton-loader
                    
                    type="image"
                  ></v-skeleton-loader>
                </v-card>
                <div v-if="!process.load">
                  <div id="chart" class="d-flex justify-center">
                    <apexchart type="pie" height="350" :options="tipe_penjualan.chartOptions" :series="tipe_penjualan.series"></apexchart>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <v-card flat class="box-shadow">
              <v-card-text>
                <div class="d-flex pb-0">
                  <div>
                    <div class="fs-16 font-weight-medium">
                      Per Metode Pembayaran
                    </div>
                    <div class="mt-0 fs-14">
                      <div>
                        {{ selected_date.name }} <span v-if="selected_date.name !== 'Semua Tanggal'">(
                          <span v-if="selected_date.start === selected_date.end">{{ selected_date.start | date_full }}</span>
                          <span v-else>{{ selected_date.start | date_full }} - {{ selected_date.end | date_full }}</span>
                          )</span>
                      </div>
                    </div>
                  </div>
                  <div class="ml-auto">
                    <v-card flat class="pa-3" height="60px" width="60px" style="border-radius: 10px; background-color: #eee;">
                      <v-img :src="require('@/assets/icon/percent.png')" width="55px"></v-img>
                    </v-card>
                  </div>
                </div>
                <v-divider class="mt-2"></v-divider>
                <v-card flat style="border-radius: 10px; background-color: #4527A0;" v-if="process.load">
                  <v-skeleton-loader
                    
                    type="image"
                  ></v-skeleton-loader>
                </v-card>
                <div v-if="!process.load">
                  <div id="chart" class="d-flex justify-center">
                    <apexchart type="pie" height="350" :options="metode_pembayaran.chartOptions" :series="metode_pembayaran.series"></apexchart>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <v-card flat class="box-shadow">
              <v-card-text>
                <div class="d-flex pb-0">
                  <div>
                    <div class="fs-16 font-weight-medium">
                      Top 5 Kategori Produk Terjual
                    </div>
                    <div class="mt-0 fs-14">
                      <div>
                        {{ selected_date.name }} <span v-if="selected_date.name !== 'Semua Tanggal'">(
                          <span v-if="selected_date.start === selected_date.end">{{ selected_date.start | date_full }}</span>
                          <span v-else>{{ selected_date.start | date_full }} - {{ selected_date.end | date_full }}</span>
                          )</span>
                      </div>
                    </div>
                  </div>
                  <div class="ml-auto">
                    <v-card flat class="pa-3" height="60px" width="60px" style="border-radius: 10px; background-color: #eee;">
                      <v-img :src="require('@/assets/icon/analytics.png')" width="55px"></v-img>
                    </v-card>
                  </div>
                </div>
                <v-divider class="mt-2"></v-divider>
                <v-card flat style="border-radius: 10px; background-color: #AD1457;" v-if="process.load">
                  <v-skeleton-loader
                    
                    type="image"
                  ></v-skeleton-loader>
                </v-card>
                <div v-if="!process.load">
                  <div id="chart" class="d-flex justify-center">
                    <apexchart type="pie" height="350" :options="top_5_category.chartOptions" :series="top_5_category.series"></apexchart>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <v-card flat class="box-shadow">
              <v-card-text>
                <div class="d-flex pb-0">
                  <div>
                    <div class="fs-16 font-weight-medium">
                      Top 5 Produk Terjual
                    </div>
                    <div class="mt-0 fs-14">
                      <div>
                        {{ selected_date.name }} <span v-if="selected_date.name !== 'Semua Tanggal'">(
                          <span v-if="selected_date.start === selected_date.end">{{ selected_date.start | date_full }}</span>
                          <span v-else>{{ selected_date.start | date_full }} - {{ selected_date.end | date_full }}</span>
                          )</span>
                      </div>
                    </div>
                  </div>
                  <div class="ml-auto">
                    <v-card flat class="pa-3" height="60px" width="60px" style="border-radius: 10px; background-color: #eee;">
                      <v-img :src="require('@/assets/icon/dash_persen.png')" width="55px"></v-img>
                    </v-card>
                  </div>
                </div>
                <v-divider class="mt-2"></v-divider>
                <v-card flat style="border-radius: 10px; background-color: #C62828;" v-if="process.load">
                  <v-skeleton-loader
                    
                    type="image"
                  ></v-skeleton-loader>
                </v-card>
                <div v-if="!process.load">
                  <div id="chart" class="d-flex justify-center">
                    <apexchart type="pie" height="350" :options="top_5_product.chartOptions" :series="top_5_product.series"></apexchart>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- <v-col cols="12" md="4">
            <v-card flat class="box-shadow">
              <v-card-text>
                <div class="d-flex pb-0">
                  <div>
                    <div class="fs-16 font-weight-medium">
                      Top 5 Tipe Pelanggan
                    </div>
                    <div class="mt-0 fs-14">
                      Minggu Ini
                    </div>
                  </div>
                  <div class="ml-auto">
                    <v-card flat class="pa-3" height="60px" width="60px" style="border-radius: 10px; background-color: #eee;">
                      <v-img :src="require('@/assets/icon/metode.png')" width="55px"></v-img>
                    </v-card>
                  </div>
                </div>
                <v-divider class="mt-2"></v-divider>
                <div id="chart">
                  <apexchart type="pie" height="350" :options="top_5_product.chartOptions" :series="top_5_product.series"></apexchart>
                </div>
              </v-card-text>
            </v-card>
          </v-col> -->
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>


<script>

  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        selected: 0,
        dialog: {
          filter: false,
          fullscreen: false
        },
        filter: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          month_text: '',
          start_date: new Date().toISOString().substr(0, 10),
          end_date: '',
          date: {
            start: '',
            end: ''
          }
        },
        selected_date: {
          name: 'Semua Tanggal',
          start: '',
          end: ''
        },
        filter_list: [
          {
            name: "Semua Tanggal",
            date: {
              start: "",
              end: ""
            }
          },
          {
            name: "Rentang Tanggal",
            date: {
              start: new Date().toISOString().substr(0, 10),
              end: ""
            }
          },
          {
            name: "Hari Ini",
            date: {
              start: new Date().toISOString().substr(0, 10),
              end: new Date().toISOString().substr(0, 10)
            }
          },
          {
            name: "Kemarin",
            date: {
              start: new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().substr(0, 10),
              end: new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().substr(0, 10)
            }
          },
          {
            name: "Minggu Ini",
            date: {
              start: new Date(new Date().setDate(new Date().getDate() - new Date().getDay()+1)).toISOString().substr(0, 10),
              end: new Date(new Date().setDate(new Date().getDate() - new Date().getDay()+7)).toISOString().substr(0, 10)
            }
          },
          {
            name: "Minggu Kemarin",
            date: {
              start: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - new Date().getDay()-5).toISOString().substr(0, 10),
              end: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - new Date().getDay()+1).toISOString().substr(0, 10)
            }
          },
          {
            name: "7 hari Terakhir",
            date: {
              start: new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().substr(0, 10),
              end: new Date().toISOString().substr(0, 10)
            }
          },
          {
            name: "30 hari Terakhir",
            date: {
              start: new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().substr(0, 10),
              end: new Date().toISOString().substr(0, 10)
            }
          },
          {
            name: "Bulan Ini",
            date: {
              start: new Date(new Date().getFullYear(), new Date().getMonth() - 0, 2).toISOString().substr(0, 10),
              end: new Date(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1)).toISOString().substr(0, 10)
            }
          },
          {
            name: "Bulan Kemarin",
            date: {
              start: new Date(new Date(new Date().getFullYear(), (new Date().getMonth() - 1), 2)).toISOString().substr(0, 10),
              end: new Date(new Date(new Date().getFullYear(), (new Date().getMonth() - 1) + 1, 0)).toISOString().substr(0, 10)
            }
          },
          {
            name: "Tahun Ini",
            date: {
              start: new Date(new Date((new Date()).getFullYear(), 0, 2)).toISOString().substr(0, 10),
              end: new Date(new Date((new Date()).getFullYear(), 11, 32)).toISOString().substr(0, 10)
            }
          },
          {
            name: "Tahun Kemarin",
            date: {
              start: new Date(new Date().getFullYear() - 1, 0, 2, 1).toISOString().substr(0, 10),
              end: new Date(new Date().getFullYear() - 1, 11, 32, 1).toISOString().substr(0, 10)
            }
          }
        ],
        detail: {},
        series: [{
            name: "Jumlah Penjualan",
            data: [30, 40, 35, 50, 49, 60, 70, 91, 125]
        }],
        chartOptions: {
          chart: {
            type: 'bar',
            height: 350,
            zoom: {
              enabled: false
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'straight'
          },
          
          title: {
            text: 'Grafik Penjualan',
            align: 'left'
          },
          subtitle: {
            text: 'Grafik Penjualan Gross Sales Vs Net Sales Vs Net Profit',
            align: 'left'
          },
          labels: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September'],
          xaxis: {
            // type: 'datetime',
          },
          yaxis: {
            opposite: true
          },
          legend: {
            horizontalAlign: 'left'
          }
        },
        top_5_product: {
          series: [44, 55, 13, 43, 22],
          chartOptions: {
            chart: {
              width: 380,
              type: 'pie',
            },
            labels: ['Team A', 'Team B', 'Team C', 'Team D', 'Team E'],
            legend: {
              position: 'bottom',
            },
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom',
                }
              }
            }]
          },
        },

        top_5_category: {
          series: [44, 55, 13, 43, 22],
          chartOptions: {
            chart: {
              width: 380,
              type: 'pie',
            },
            labels: ['Team A', 'Team B', 'Team C', 'Team D', 'Team E'],
            legend: {
              position: 'bottom',
            },
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom',
                }
              }
            }]
          },
        },

        metode_pembayaran: {
          series: [44, 55, 13, 43, 22],
          chartOptions: {
            chart: {
              width: 380,
              type: 'pie',
            },
            labels: ['Team A', 'Team B', 'Team C', 'Team D', 'Team E'],
            legend: {
              position: 'bottom',
            },
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom',
                }
              }
            }]
          },
        },

        tipe_penjualan: {
          series: [44, 55, 13, 43, 22],
          chartOptions: {
            chart: {
              width: 380,
              type: 'pie',
            },
            labels: ['Team A', 'Team B', 'Team C', 'Team D', 'Team E'],
            legend: {
              position: 'bottom',
            },
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom',
                }
              }
            }]
          },
        },

        process: {
          load: true
        },
        menu: []
        
      }
    },
    computed: {
      years () {
        let max = new Date().getFullYear()+2, min = max - 2, years = []

        this.filter.year = this.$store.state.year

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      },
      user () {
        return this.$store.state.user
      },
      outlet () {
        return this.$store.state.outlet
      },
      set_color () {
        return this.$store.state.color
      }
    },
    mounted () {
      let dashboard = false
      this.$store.state.menu.map(item => {
        if (item.name === 'Dashboard') {
          dashboard = true
        }
      })
      let menu = [],
        menu_konfigurasi = [],
        is_konfigurasi = true,
        is_profile = true,
        menu_profile = this.$store.state.menu
    menu_profile.map((item, index) => {
      if(item.link === '/konfigurasi') {
      // if((item.sub_menu.label === 'edit profile') === false) {
      // console.log(item.sub_menu.label === 'Edit Profile')
      is_profile = item.sub_menu.filter((item) => item.label === 'Edit Profile')
        }
        })
        // console.log(item.sub_menu)
        // console.log(is_profile)
        is_profile = is_profile.length < 1 ?  false : true
    menu_profile.map((item, index) => {
      if(item.link === '/konfigurasi') {
        // }
        if(is_profile === false) {
          item.sub_menu.push(
            {
              id: 10000,
              label: "Edit Profile",
              icon: "mdi-file-cog",
              link: "/konfigurasi/profile"
            },
            {
              id: 10001,
              label: "Ganti Password",
              icon: "mdi-file-cog",
              link: "/konfigurasi/ganti-password"
            }
          )
        }
        }
    })

    this.$store.state.menu.map((item, index) => {
      menu_konfigurasi.push(item)
    })
      // console.log(item.link === '/konfigurasi')
    is_konfigurasi = this.$store.state.menu.filter((item) => item.link === '/konfigurasi')
    // console.log(is_konfigurasi)
    is_konfigurasi = is_konfigurasi.length < 1 ? false : true
    if(is_konfigurasi === false) {
      menu_profile.push(
        {
          id: 39,
          label: "Konfigurasi",
          icon: "mdi-file-cog",
          link: "/konfigurasi",
          sub_menu: [
            {
              id: 10000,
              label: "Edit Profile",
              icon: "mdi-file-cog",
              link: "/konfigurasi/profile"
            },
            {
              id: 10001,
              label: "Ganti Password",
              icon: "mdi-file-cog",
              link: "/konfigurasi/ganti-password"
            }
          ]
        }
      )
    }
    // console.log(menu_profile)
    // menu_konfigurasi.push(
    //   {
    //     id: 39,
    //     label: "Konfigurasi",
    //     icon: "mdi-file-cog",
    //     link: "/konfigurasi",
    //     sub_menu: [
    //       {
    //         id: 10000,
    //         label: "Edit Profile",
    //         icon: "mdi-file-cog",
    //         link: "/konfigurasi/profile"
    //       },
    //       {
    //         id: 10001,
    //         label: "Ganti Password",
    //         icon: "mdi-file-cog",
    //         link: "/konfigurasi/ganti-password"
    //       }
    //     ]
    //   }
    // )
    // console.log(menu_konfigurasi)
    
    this.$store.state.menu.map((item, index) => {
      // console.log((item.link).split('-').join('/'))
      // console.log((item.link === '/konfigurasi') )
      if((item.link === '/konfigurasi') === false){
        // this.$store.state.menu = menu_konfigurasi
      } else {
        if(item.link === '/konfigurasi') {
          // item.sub_menu = menu_profile
        }
      }
    })
    // console.log(this.$store.state.menu)
    this.$store.state.menu.map((item, index) => {
      // console.log((item.link).split('-').join('/'))
      if(((item.link).split('-').join('/')).split('/')[1] === "master") {
        // console.log(item.sub_menu)
        menu.push(item)
      }
      // return item
    })
    let menu_master = []
    this.$store.state.menu.map((item, index) => {
      // console.log((item.link).split('-').join('/'))
      if(((item.link).split('-').join('/')).split('/')[1] !== "master") {
        // console.log(item.sub_menu)
        menu_master.push(item)
      }
      // return item
    })
    let menu_with_master = menu_master
    menu_with_master.push(
      {
        label: "Master",
        icon: "mdi-cog-outline",
        link: "/menu-master"
      }
    )
    this.menu = menu.length > 0 ? menu_with_master : this.$store.state.menu

      if (!dashboard) {
        this.$router.push(this.menu[0].link)
      }
      this.fetch()
    },
    methods: {
      async fetch () {
        this.process.load = true
        this.selected_date.start = this.filter_list[this.selected].date.start
        this.selected_date.end = this.filter_list[this.selected].date.end
        this.selected_date.name = this.filter_list[this.selected].name
        this.dialog.filter = false
  
        let params = {
          outlet_id: this.outlet.outlet_id,
          // 'date[gte]': this.filter.start_date,
          // 'date[lte]': this.filter.end_date
          start_date: this.filter_list[this.selected].date.start,
          end_date: this.filter_list[this.selected].date.end,
          // date: this.filter.start_date
        }
  
        await get(`pos/dashboard/data`, { params })
        .then(response => {
          let res = response.data
  
          this.process.load = false
  
          if (res.status === 200) {
            this.detail = res.results.data
            let data_value = []
            res.results.data.grafik_penjualan.value = res.results.data.grafik_penjualan.value === undefined ? [] : res.results.data.grafik_penjualan.value.map(item => {
              data_value.push({
                name: item.name,
                data: item.data.map(item => {
                  return item*1
                })
              })
            })
            res.results.data.grafik_penjualan.label = res.results.data.grafik_penjualan.label === undefined ? [] : res.results.data.grafik_penjualan.label.map(item => {
              return moment(item).format('DD MMMM YYYY')
            })
            this.series = res.results.data.grafik_penjualan.value === undefined ? [] : data_value
            this.chartOptions = {
              chart: {
                type: 'bar',
                height: 450,
                zoom: {
                  enabled: false
                }
              },
              dataLabels: {
                enabled: false
              },
              stroke: {
                curve: 'straight'
              },
              colors: ['#455A64', '#EF6C00', '#039BE5', '#00ACC1'],
              
              title: {
                text: 'Grafik Penjualan',
                align: 'left'
              },
              subtitle: {
                text: 'Grafik Penjualan Gross Sales Vs Net Sales Vs Net Profit Minggu Ini',
                align: 'left'
              },
              labels: res.results.data.grafik_penjualan.label === undefined ? [] : res.results.data.grafik_penjualan.label,
              xaxis: {
                // labels: {
                //   format: 'dd MMMM yyyy',
                // }
                // type: 'numeric',

              },
              yaxis: {
                opposite: true,
                labels: {
                  formatter: function (value) {
                    let val = (value/1)
                    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                  }
                },
              },
              legend: {
                horizontalAlign: 'center',
                position: 'top',
                offsetY: -15

              }
            }

            this.metode_pembayaran = {
              series: res.results.data.metode_pembayaran.length > 0 ? res.results.data.metode_pembayaran[0].series === undefined ? [] : res.results.data.metode_pembayaran[0].series.map(item => {
                return item*1
              }) : [],
              chartOptions: {
                chart: {
                  width: 380,
                  type: 'pie',
                },
                labels: res.results.data.metode_pembayaran.length > 0 ? res.results.data.metode_pembayaran[0].labels === undefined ? [] : res.results.data.metode_pembayaran[0].labels : [],
                legend: {
                  position: 'bottom',
                },
                responsive: [{
                  breakpoint: 480,
                  options: {
                    chart: {
                      width: 200
                    },
                    legend: {
                      position: 'bottom',
                    }
                  }
                }]
              }
            }

            this.tipe_penjualan = {
              series: res.results.data.tipe_penjualan.length > 0 ? res.results.data.tipe_penjualan[0].series === undefined ? [] : res.results.data.tipe_penjualan[0].series.map(item => {
                return item*1
              }) : [],
              chartOptions: {
                chart: {
                  width: 380,
                  type: 'pie',
                },
                labels: res.results.data.tipe_penjualan.length > 0 ? res.results.data.tipe_penjualan[0].labels === undefined ? [] : res.results.data.tipe_penjualan[0].labels : [],
                legend: {
                  position: 'bottom',
                },
                responsive: [{
                  breakpoint: 480,
                  options: {
                    chart: {
                      width: 200
                    },
                    legend: {
                      position: 'bottom',
                    }
                  }
                }]
              }
            }

            this.top_5_category = {
              series: res.results.data.top_5_category.length > 0 ? res.results.data.top_5_category[0].series === undefined ? [] : res.results.data.top_5_category[0].series.map(item => {
                return item*1
              }) : [],
              chartOptions: {
                chart: {
                  width: 380,
                  type: 'pie',
                },
                labels: res.results.data.top_5_category.length > 0 ? res.results.data.top_5_category[0].labels === undefined ? [] : res.results.data.top_5_category[0].labels : [],
                legend: {
                  position: 'bottom',
                },
                responsive: [{
                  breakpoint: 480,
                  options: {
                    chart: {
                      width: 200
                    },
                    legend: {
                      position: 'bottom',
                    }
                  }
                }]
              }
            }

            this.top_5_product = {
              series: res.results.data.top_5_product.length > 0 ? res.results.data.top_5_product[0].series === undefined ? [] : res.results.data.top_5_product[0].series.map(item => {
                return item*1
              }) : [],
              chartOptions: {
                chart: {
                  width: 380,
                  type: 'pie',
                },
                labels: res.results.data.top_5_product.length > 0 ? res.results.data.top_5_product[0].labels === undefined ? [] : res.results.data.top_5_product[0].labels : [],
                legend: {
                  position: 'bottom',
                },
                responsive: [{
                  breakpoint: 480,
                  options: {
                    chart: {
                      width: 200
                    },
                    legend: {
                      position: 'bottom',
                    }
                  }
                }]
              }
            }
          }
        })
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      }
    }
  }
</script>